import { createFileRoute } from "@tanstack/react-router"
import { CustomizationForm } from "modules/settings/components/Company/CustomizationForm"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { z } from "zod"

const SearchSchema = z.object({
  tab: z.enum(["company", "agent", "email"]).catch("company"),
})

export const Route = createFileRoute("/_base/_auth/settings/customization")({
  component: CustomizationForm,
  validateSearch: SearchSchema,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.company.customization.title"),
    })
  },
})
